import { CurrentUser } from 'api/currentUser';
import {
  isLoggedIn,
  isNonAdmin,
  isSalarySurveyCompleted,
} from 'utils/currentUser';
import {
  NOTIFICATIONS,
  notificationIsDismissed,
} from 'utils/localNotifications';

export const promoteSalarySurvey = ({
  allowDismissal,
  currentUser,
}: {
  allowDismissal?: boolean;
  currentUser: CurrentUser;
}) =>
  (!allowDismissal ||
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
    !notificationIsDismissed(NOTIFICATIONS.SALARY_SURVEY_CTA)) &&
  currentUser.isLoaded &&
  CURRENT_LOCALE === 'en' &&
  currentUser.isUS &&
  !isSalarySurveyCompleted(currentUser) &&
  (!isLoggedIn(currentUser) || isNonAdmin(currentUser));

export const promoteSalarySurveySearchAd = ({
  currentUser,
}: {
  currentUser: CurrentUser;
}) =>
  currentUser.isLoaded &&
  CURRENT_LOCALE === 'en' &&
  currentUser.isUS &&
  !isSalarySurveyCompleted(currentUser);
